import { action, thunk } from 'easy-peasy';

export default {
	loading: false,
	setLoading: action((state, payload) => {
		state.loading = payload;
	}),
	isWishlist: false,
	setIsWishlist: action((state, payload) => {
		state.loading = payload;
	}),
	scope: '',
	setScope: action((state, payload) => {
		state.scope = payload;
	}),
	sendRequest: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		const { history, redirect, successMessage, goBack = true, refresh = false, returnDetail = '' } = payload;
		actions.setLoading(true);
		return services.wishlist
			.addToWishlist(payload)
			.then(data => {
				//Se il servizio risponde in 200 e non ci sono items restituiti significa
				//che la WL è speciale e ci sono quantità < 10
				if (data.items.length == 0) {
					getStoreActions().error('wishlist.specialWLError');
					//Se arrivo dal dettaglio reinserisco l'history per abilitare la chiusura della modale dettaglio
					if (returnDetail != '' && redirect == '/catalog/search') {
						history.push('/catalog/search/details/' + returnDetail);
					}
					return;
				} else {
					getStoreActions().successCustom(successMessage);
					getStoreActions().selection.closeModal(); //Sostituito all'actionOn per gestire le WL speciali
					getStoreActions().catalog.details.setModalOpen(false); //Sostituito alla chiamata nel componente Order.js della scheda dettaglio
					if (redirect && redirect !== '') {
						history.push(redirect);
						if (refresh) {
							history.go();
						}
					} else if (goBack) {
						history.goBack();
					}
					return Promise.resolve(data);
				}
			})
			.catch(e => {
				getStoreActions().error('order.create');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	})
};
